type Narrowable = string | number | boolean | symbol | object | {} | void | null | undefined;
export const createType = <T extends Narrowable[]>(...args: T) => args;